module.exports = __webpack_public_path__ + "static/VTFMisterPixel-Tools-3ed1f2c1bf2f0094897d9a39b324be47.eot";